export default "__VITE_PUBLIC_ASSET__caf9de66__"